import React from 'react';
import { Mock } from '../models/Mock';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';

export const CardComponent = (props: Mock) => {
    const navigate = useNavigate();
    return (
        <Button
            className="card-element button-style glow-on-hover"
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            onClick={() => navigate(`${PRIVATE_ROUTES.PATH}/${props.redirect}`)}
        >
            {props.image}
            <div style={{ height: '120%', width: 239 }}>
                <p className="title">{props.title}</p>
                <p className="description">
                    {props.description.map((text, index) => (
                        <React.Fragment key={index}>
                            {text}
                            <br />
                        </React.Fragment>
                    ))}
                </p>
            </div>
        </Button>
    );
};
